import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button, EmptyState } from '@/components';
import {
  PublicProfileFrame,
  PublicProfilePage,
} from '@/components/profile/PublicProfilePage';
import { useInterfaceLanguage } from '@/lib/interface-language';
import { profilePageQueryOptions } from '@/lib/profile-page';
import { signInHref, useSession } from '@/lib/session';

export const Route = createFileRoute('/users/$userId')({
  component: PublicProfileRoute,
});

function PublicProfileRoute() {
  const { t } = useInterfaceLanguage();
  const { userId } = Route.useParams();
  const navigate = useNavigate();
  const { isSignedOut, isPending } = useSession();
  const profilePage = useQuery({
    ...profilePageQueryOptions(userId),
    enabled: !isSignedOut && !isPending,
  });

  if (isSignedOut) {
    return (
      <PublicProfileFrame title={t('publicProfile.title')}>
        <EmptyState
          tone="neutral"
          size="panel"
          headingLevel={2}
          title={t('publicProfile.signInTitle')}
          body={t('publicProfile.signInBody')}
          action={
            <Button
              as="a"
              variant="primary"
              href={signInHref({ pathname: `/users/${userId}`, search: '' })}
            >
              {t('publicProfile.signInAction')}
            </Button>
          }
        />
      </PublicProfileFrame>
    );
  }

  return (
    <PublicProfilePage
      data={profilePage.data ?? null}
      loading={isPending || profilePage.isLoading}
      error={profilePage.error?.message ?? null}
      onOpenBoard={(path) => {
        void navigate({ to: path });
      }}
      onOpenCard={(intent) => {
        void navigate({ to: intent.path });
      }}
    />
  );
}
